import axios from 'axios';
import { getToken, setToken } from './jwt';

const api = axios.create({
    baseURL: 'https://noohraserver.onrender.com/api/v1/',
    headers: { 'Content-Type': 'application/json' },
});

// Read the token on every request so login/logout take effect immediately.
api.interceptors.request.use((config) => {
    const token = getToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

/**
 * Turns any request failure (HTTP error, timeout, offline) into a readable message.
 */
export const getErrorMessage = (error, fallback = 'Something went wrong. Please try again.') =>
    error?.response?.data?.message ||
    (error?.request && !error?.response ? 'Could not reach the server. Please check your connection and try again.' : null) ||
    fallback;

export const createUser = async (payload) => {
    const response = await api.post('auth/signup', payload);
    return response.data;
};

export const loginUser = async (payload) => {
    const response = await api.post('auth/login', payload);
    const token = response.data?.data?.token;
    if (token) {
        setToken(token);
    }
    return response.data;
};

export const getUser = async () => {
    const response = await api.get('auth/me');
    return response.data;
};

export const getAllUsers = async () => {
    const response = await api.get('auth/userList');
    return response.data;
};

export const getBookings = async () => {
    const response = await api.get('booking');
    return response.data;
};

export const createBooking = async (payload) => {
    const response = await api.post('booking', payload);
    return response.data;
};

export const getServices = async (type, location) => {
    const params = {};
    if (type) params.type = type;
    if (location) params.location = location;
    const response = await api.get('services', { params });
    return response.data;
};

export const editService = async (id, payload) => {
    const response = await api.patch(`services/${id}`, payload);
    return response.data;
};

export const getGallery = async () => {
    const response = await api.get('gallery');
    return response.data;
};

export const postImage = async (imageFiles) => {
    const formData = new FormData();
    imageFiles.forEach((file) => formData.append('images', file));
    const response = await api.post('gallery', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
};

export const deleteImage = async (id) => {
    const response = await api.delete(`gallery/${id}`);
    return response.data;
};
